export function getDefaultDateRangeForm() {
  return {
    startDate: "",
    endDate: "",
  };
}

export function formatDateFr(value) {
  if (!value) return "";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleDateString("fr-FR");
}

export function formatDateRange(startDate, endDate) {
  if (!startDate || !endDate) return "—";

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return "—";
  }

  const formatter = new Intl.DateTimeFormat("fr-FR");

  if (typeof formatter.formatRange === "function") {
    return formatter.formatRange(start, end);
  }

  return `${formatDateFr(startDate)} → ${formatDateFr(endDate)}`;
}

export function validateDateRangeForm(form) {
  if (!form?.startDate || !form?.endDate) {
    return "Veuillez sélectionner une date de début et une date de fin.";
  }

  const start = new Date(form.startDate);
  const end = new Date(form.endDate);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return "La période sélectionnée est invalide.";
  }

  if (start > end) {
    return "La date de début ne peut pas être postérieure à la date de fin.";
  }

  return "";
}

export function buildConfirmMessage({ label, startDate, endDate }) {
  return `Confirmez-vous la suppression des ${label} entre le ${formatDateFr(
    startDate
  )} et le ${formatDateFr(endDate)} ?`;
}